import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store";
import "antd/dist/antd.css";

import Layout from "./components/layout";
import { PersistGate } from "redux-persist/lib/integration/react";

const isResizeObserverNoise = (message = "") =>
  message.includes("ResizeObserver loop limit exceeded") ||
  message.includes("ResizeObserver loop completed with undelivered notifications");

if (window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver {
    constructor(callback) {
      this.observer = new NativeResizeObserver((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }

    observe(target, options) {
      this.observer.observe(target, options);
    }

    unobserve(target) {
      this.observer.unobserve(target);
    }

    disconnect() {
      this.observer.disconnect();
    }
  };
}

const originalConsoleError = console.error;
console.error = (...args) => {
  const combinedMessage = args
    .map((arg) => String(arg?.message || arg || ""))
    .join(" ");

  if (isResizeObserverNoise(combinedMessage)) {
    return;
  }

  originalConsoleError(...args);
};

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverNoise(event?.message || "")) {
      event.stopImmediatePropagation?.();
      event.preventDefault?.();
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = String(event?.reason || "");
    if (isResizeObserverNoise(reason)) {
      event.stopImmediatePropagation?.();
      event.preventDefault?.();
    }
  },
  true
);

const rootElement = document.getElementById("root");
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Layout>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Layout>
    </PersistGate>
  </Provider>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
